import { useNavigate } from "react-router-dom";
import { ShieldX, LogOut, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/services/supabase";

export default function AccessDeniedPage() {
  const navigate = useNavigate();
  const { signOut, user } = useAuth() ?? { signOut: async () => {}, user: null };

  const handleSignOut = async () => {
    await signOut();
    navigate("/login", { replace: true });
  };

  return (
    <main className="flex min-h-screen items-center justify-center px-5 py-10 bg-background" data-testid="access-denied-page">
      <Card className="max-w-md border-border/80 shadow-soft" data-testid="access-denied-card">
        <CardHeader className="pb-4 text-center">
          <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-destructive/10">
            <ShieldX className="size-6 text-destructive" />
          </div>
          <CardTitle className="text-xl" data-testid="access-denied-title">Access not authorized</CardTitle>
          <CardDescription data-testid="access-denied-description">
            Your account is not linked to an active ACZON staff profile.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground" data-testid="access-denied-detail">
            {user?.email ? <>Signed in as <span className="font-medium text-foreground">{user.email}</span>.</> : null}
            {" "}Please contact your administrator to request access to the ARISE operations workspace.
          </p>
          <div className="flex gap-3">
            <Button variant="outline" className="flex-1" onClick={() => navigate("/login")} data-testid="access-denied-back">
              <ArrowLeft className="mr-2 size-4" /> Back to login
            </Button>
            <Button variant="default" className="flex-1" onClick={handleSignOut} data-testid="access-denied-logout">
              <LogOut className="mr-2 size-4" /> Sign out
            </Button>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
